import { RangeQueryInterface } from '@sport-activities/sdk';

import { UpdateFilterPayloadInterface } from '~/attendee/interfaces/update-filter-payload.interface';

export function isRangeEvent(
  updatePayload: UpdateFilterPayloadInterface<unknown>
): updatePayload is UpdateFilterPayloadInterface<RangeQueryInterface<unknown>> {
  return updatePayload.type === 'RANGE';
}
